export const loginBtnTxt = 'login-btn-txt';
export const loginFormTitle = 'login-form-title';
export const loginSignupMessage = 'login-signup-message';
export const loginSignupLink = 'login-signup-link';
export const loginRememberDevice = 'login-remember-device';
export const registerHeaderTitle = 'register-header-title';
export const registerHeaderDescription = 'register-header-description';
export const registerLoginLink = 'register-login-link';
export const registerFirstNameLabel = 'register-first-name-label';
export const registerFirstNamePlaceHolder = 'register-first-name-place-holder';
export const registerLastNameLabel = 'register-last-name-label';
export const registerLastNamePlaceHolder = 'register-last-name-place-holder';
export const registerEmailLabel = 'register-email-label';
export const registerEmailPlaceHolder = 'register-email-place-holder';
export const registerPhoneNumberLabel = 'register-phone-number-label';
export const registerPhoneNumberPlaceHolder =
    'register-phone-number-place-holder';
export const registerCompanyInfoTxt = 'register-company-info-txt';
export const registerSupplierTitleLabel = 'register-supplier-title-label';
export const registerSupplierTitlePlaceHolder =
    'register-supplier-title-place-holder';
export const registerSupplierCompanyLabel = 'register-supplier-company-label';
export const registerSupplierCompanyPlaceHolder =
    'register-supplier-company-place-holder';
export const registerBtnTxt = 'register-btn-txt';
export const forgetPasswordHeaderTitle = 'forget-password-header-title';
export const forgetPasswordHeaderDescription =
    'forget-password-header-description';
export const forgetPasswordLoginLink = 'forget-password-login-link';
export const forgetPasswordEmailLabel = 'forget-password-email-label';
export const forgetPasswordEmailPlaceHolder =
    'forgetPassword-email-place-holder';
export const forgetPasswordBtnTxt = 'forget-password-btn-txt';
export const updateUserFirstNameLabel = 'update-user-first-name-label';
export const updateUserFirstNamePlaceHolder =
    'update-user-first-name-place-holder';
export const updateUserLastNameLabel = 'update-user-last-name-label';
export const updateUserLastNamePlaceHolder =
    'update-user-last-name-place-holder';
export const updateUserEmailLabel = 'update-user-email-label';
export const updateUserEmailPlaceHolder = 'update-user-email-place-holder';
export const updateUserPhoneNumberLabel = 'update-user-phone-number-label';
export const updateUserPhoneNumberPlaceHolder =
    'update-user-phone-number-place-holder';
export const updateUserCompanyInfoTxt = 'update-user-company-info-txt';
export const updateUserSupplierTitleLabel = 'update-user-supplier-title-label';
export const updateUserSupplierTitlePlaceHolder =
    'update-user-supplier-title-place-holder';
export const updateUserSupplierCompanyLabel =
    'update-user-supplier-company-label';
export const updateUserSupplierCompanyPlaceHolder =
    'update-user-supplier-company-place-holder';
export const updateUserBtnTxt = 'update-user-btn-txt';
export const updateUserCancelBtnTxt = 'update-user-cancel-btn-txt';
export const changePasswordFormTitle = 'change-password-form-title';
export const changePasswordCurrentPasswordLabel =
    'change-password-current-password-label';
export const changePasswordCurrentPasswordPlaceHolder =
    'change-password-current-password-place-holder';
export const changePasswordNewPasswordLabel =
    'change-password-new-password-label';
export const changePasswordNewPasswordPlaceHolder =
    'change-password-new-password-place-holder';
export const changePasswordConfirmPasswordLabel =
    'change-password-confirm-password-label';
export const changePasswordConfirmPasswordPlaceHolder =
    'change-password-confirm-password-place-holder';
export const changePasswordBtnTxt = 'change-password-btn-txt';
export const resetPasswordFormTitle = 'reset-password-form-title';
export const resetPasswordNewPasswordLabel =
    'reset-password-new-password-label';
export const resetPasswordNewPasswordPlaceHolder =
    'reset-password-new-password-place-holder';
export const resetPasswordConfirmPasswordLabel =
    'reset-password-confirm-password-label';
export const resetPasswordConfirmPasswordPlaceHolder =
    'reset-password-confirm-password-place-holder';
export const resetPasswordBtnTxt = 'reset-password-btn-txt';
export const footerCopyrightTxt = 'footer-copyright-txt';
export const validationFirstNameRequired = 'validation-first-name-required';
export const validationFirstNameLength = 'validation-first-name-length';
export const validationFirstNameRegex = 'validation-last-name-regex';
export const validationLastNameRequired = 'validation-first-name-required';
export const validationLastNameLength = 'validation-last-name-length';
export const validationLastNameRegex = 'validation-last-name-regex';
export const validationEmailRequired = 'validation-email-required';
export const validationEmailRegex = 'validation-email-regex';
export const validationPhoneNumberRequired = 'validation-phone-number-required';
export const validationPhoneNumberRegex = 'validation-phone-number-regex';
export const validationSupplierTitleRequired =
    'validation-supplier-title-required';
export const validationSupplierTitleLength = 'validation-supplier-title-length';
export const validationSupplierTitleRegex = 'validation-supplier-title-regex';
export const validationSupplierCompanyRequired =
    'validation-supplier-company-required';
export const validationSupplierCompanyLength =
    'validation-supplier-company-length';
export const validationSupplierCompanyRegex =
    'validation-supplier-company-regex';
export const validationPasswordRequired = 'validation-password-required';
export const validationPasswordRegex = 'validation-password-regex';
export const validationCurrentPasswordRequired =
    'validation-current-password-required';
export const validationCurrentPasswordRegex =
    'validation-current-password-regex';
export const validationNewPasswordRequired = 'validation-new-password-required';
export const validationNewPasswordRegex = 'validation-new-password-regex';
export const validationConfirmPasswordRequired =
    'validation-confirm-password-required';
export const validationConfirmPasswordRegex =
    'validation-confirm-password-regex';

export const reportTotalsItemsText = 'report-totals-items-text';
export const reportTotalsClientsText = 'report-totals-clients-text';
export const reportTotalsSalesText = 'report-totals-sales-text';
export const reportTotalsQuantitiesText = 'report-totals-quantities-text';

export const reportTotalsBranchesText = 'report-totals-branches-text';
export const reportTotalsStocksText = 'report-totals-stocks-text';
export const reportTotalsBricksText = 'report-totals-bricks-text';
